import { Formik } from "formik";
import { Form, Col, Row } from "react-bootstrap";

export function UsernameAndPasswordChangeForm({ 
  usernameAndPassword,
  btnRef,
  updateUsernameAndPassword
}) {
  return (
    <Formik 
      enableReinitialize={true}
      initialValues={usernameAndPassword}
      onSubmit={(values) => updateUsernameAndPassword(values)}
    >
      {({ handleSubmit, handleChange, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
         <Form.Group as={Row} controlId="username">
            <Form.Label column sm={2}>
              Kullanıcı Adı <span>*</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.username} placeholder="Kullanıcı Adı" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="password">
            <Form.Label column sm={2}>
              Mevcut Şifre
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="password" value={values.password} placeholder="Mevcut Şifre" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="newPassword">
            <Form.Label column sm={2}>
              Yeni Şifre
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="password" value={values.newPassword} placeholder="Yeni Şifre" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="newPasswordConfirm">
            <Form.Label column sm={2}>
              Yeni Şifre Tekrar
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="password" value={values.newPasswordConfirm} placeholder="Yeni Şifre Tekrar" onChange={handleChange} />
            </Col>
          </Form.Group>

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}